module.exports = __webpack_public_path__ + "static/media/playercontrols.2ee6c6f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/elements/screen-images/music/playercontrols.png
// module id = 713
// module chunks = 0